// Do not edit manually

export const IMAGES = {
  CATFIGHT_NEW_TAGLINE_POSTER_1_4: "/images/catfight_new_tagline_poster_1.jpg",
  CHAOS_COMPLETE_STORYLINE_POSTER_1_1: "/images/chaos_complete_storyline_poster_1.jpg",
  CROPPED_IMAGE_0_1777039613271390820_41: "/images/cropped_image_0_1777039613271390820.jpg",
  CROPPED_IMAGE_10_1777039611226419647_65: "/images/cropped_image_10_1777039611226419647.jpg",
  CROPPED_IMAGE_10_1777039612819539244_16: "/images/cropped_image_10_1777039612819539244.jpg",
  CROPPED_IMAGE_10_1777039613181430480_38: "/images/cropped_image_10_1777039613181430480.jpg",
  CROPPED_IMAGE_10_1777039613232024830_35: "/images/cropped_image_10_1777039613232024830.jpg",
  CROPPED_IMAGE_10_1777039613297578017_51: "/images/cropped_image_10_1777039613297578017.jpg",
  CROPPED_IMAGE_11_1777039610933925637_47: "/images/cropped_image_11_1777039610933925637.jpg",
  CROPPED_IMAGE_11_1777039613142476466_29: "/images/cropped_image_11_1777039613142476466.jpg",
  CROPPED_IMAGE_11_1777039613260356978_61: "/images/cropped_image_11_1777039613260356978.jpg",
  CROPPED_IMAGE_12_1777039611804523317_23: "/images/cropped_image_12_1777039611804523317.jpg",
  CROPPED_IMAGE_12_1777039613350613110_52: "/images/cropped_image_12_1777039613350613110.jpg",
  CROPPED_IMAGE_13_1777039612667830058_32: "/images/cropped_image_13_1777039612667830058.jpg",
  CROPPED_IMAGE_13_1777039613245694107_44: "/images/cropped_image_13_1777039613245694107.jpg",
  CROPPED_IMAGE_13_1777039613269060386_62: "/images/cropped_image_13_1777039613269060386.jpg",
  CROPPED_IMAGE_14_1777039613366126068_53: "/images/cropped_image_14_1777039613366126068.jpg",
  CROPPED_IMAGE_15_1777039611973892466_24: "/images/cropped_image_15_1777039611973892466.jpg",
  CROPPED_IMAGE_15_1777039613423272073_43: "/images/cropped_image_15_1777039613423272073.jpg",
  CROPPED_IMAGE_15_1777039613428593347_54: "/images/cropped_image_15_1777039613428593347.jpg",
  CROPPED_IMAGE_15_1777039613439273241_19: "/images/cropped_image_15_1777039613439273241.jpg",
  CROPPED_IMAGE_16_1777039612670456650_33: "/images/cropped_image_16_1777039612670456650.jpg",
  CROPPED_IMAGE_16_1777039613279107729_63: "/images/cropped_image_16_1777039613279107729.jpg",
  CROPPED_IMAGE_17_1777039613439314071_55: "/images/cropped_image_17_1777039613439314071.jpg",
  CROPPED_IMAGE_18_1777039613021533635_26: "/images/cropped_image_18_1777039613021533635.jpg",
  CROPPED_IMAGE_18_1777039613301759774_64: "/images/cropped_image_18_1777039613301759774.jpg",
  CROPPED_IMAGE_19_1777039612674709927_34: "/images/cropped_image_19_1777039612674709927.jpg",
  CROPPED_IMAGE_19_1777039613309876569_40: "/images/cropped_image_19_1777039613309876569.jpg",
  CROPPED_IMAGE_19_1777039613451277215_56: "/images/cropped_image_19_1777039613451277215.jpg",
  CROPPED_IMAGE_1_1777039540302372752_67: "/images/cropped_image_1_1777039540302372752.jpg",
  CROPPED_IMAGE_1_1777039611695098983_30: "/images/cropped_image_1_1777039611695098983.jpg",
  CROPPED_IMAGE_1_1777039612976225418_39: "/images/cropped_image_1_1777039612976225418.jpg",
  CROPPED_IMAGE_1_1777039613051213994_27: "/images/cropped_image_1_1777039613051213994.jpg",
  CROPPED_IMAGE_2_1777039611765793968_31: "/images/cropped_image_2_1777039611765793968.jpg",
  CROPPED_IMAGE_2_1777039612957238312_25: "/images/cropped_image_2_1777039612957238312.jpg",
  CROPPED_IMAGE_3_1777039540313057025_68: "/images/cropped_image_3_1777039540313057025.jpg",
  CROPPED_IMAGE_3_1777039540645156376_66: "/images/cropped_image_3_1777039540645156376.jpg",
  CROPPED_IMAGE_3_1777039610931396641_45: "/images/cropped_image_3_1777039610931396641.jpg",
  CROPPED_IMAGE_3_1777039611777138662_20: "/images/cropped_image_3_1777039611777138662.jpg",
  CROPPED_IMAGE_3_1777039612981182850_17: "/images/cropped_image_3_1777039612981182850.jpg",
  CROPPED_IMAGE_3_1777039613026151274_48: "/images/cropped_image_3_1777039613026151274.jpg",
  CROPPED_IMAGE_3_1777039613304499065_42: "/images/cropped_image_3_1777039613304499065.jpg",
  CROPPED_IMAGE_4_1777039613165861032_36: "/images/cropped_image_4_1777039613165861032.jpg",
  CROPPED_IMAGE_4_1777039613212207072_57: "/images/cropped_image_4_1777039613212207072.jpg",
  CROPPED_IMAGE_5_1777039613042981831_49: "/images/cropped_image_5_1777039613042981831.jpg",
  CROPPED_IMAGE_6_1777039540355774400_69: "/images/cropped_image_6_1777039540355774400.jpg",
  CROPPED_IMAGE_6_1777039611786817360_21: "/images/cropped_image_6_1777039611786817360.jpg",
  CROPPED_IMAGE_6_1777039613117305364_28: "/images/cropped_image_6_1777039613117305364.jpg",
  CROPPED_IMAGE_6_1777039613220882428_58: "/images/cropped_image_6_1777039613220882428.jpg",
  CROPPED_IMAGE_7_1777039613173509040_37: "/images/cropped_image_7_1777039613173509040.jpg",
  CROPPED_IMAGE_7_1777039613215100251_50: "/images/cropped_image_7_1777039613215100251.jpg",
  CROPPED_IMAGE_8_1777039613220976008_59: "/images/cropped_image_8_1777039613220976008.jpg",
  CROPPED_IMAGE_9_1777039540368031529_70: "/images/cropped_image_9_1777039540368031529.jpg",
  CROPPED_IMAGE_9_1777039610933650166_46: "/images/cropped_image_9_1777039610933650166.jpg",
  CROPPED_IMAGE_9_1777039611796108152_22: "/images/cropped_image_9_1777039611796108152.jpg",
  CROPPED_IMAGE_9_1777039613080920431_18: "/images/cropped_image_9_1777039613080920431.jpg",
  CROPPED_IMAGE_9_1777039613249405205_60: "/images/cropped_image_9_1777039613249405205.jpg",
  JEENA_ISI_KA_NAAM_HAI_POSTER_2: "/images/Jeena Isi Ka Naam Hai Poster.jpg",
  KESHHAV_CAMERA_V3_1_8: "/images/keshhav_camera_v3_1.jpg",
  KESHHAV_DIRECTOR_10_1_14: "/images/keshhav_director_10_1.jpg",
  KESHHAV_DIRECTOR_12_16X9_1_15: "/images/keshhav_director_12_16x9_1.jpg",
  KESHHAV_DIRECTOR_12_ZOOMIN_1_12: "/images/keshhav_director_12_zoomin_1.jpg",
  KESHHAV_DIRECTOR_13_1_13: "/images/keshhav_director_13_1.jpg",
  KESHHAV_DIRECTOR_1_1_6: "/images/keshhav_director_1_1.jpg",
  KESHHAV_DIRECTOR_2_1_10: "/images/keshhav_director_2_1.jpg",
  KESHHAV_DIRECTOR_8_1_7: "/images/keshhav_director_8_1.jpg",
  KESHHAV_DIRECTOR_9_1_9: "/images/keshhav_director_9_1.jpg",
  KESHHAV_ONSET_1_1_11: "/images/keshhav_onset_1_1.jpg",
  KRISHNA_CONSCIOUSNESS_EPIC_NO_MARVEL_1_2968_3: "/images/krishna_consciousness_epic_no_marvel_1_2968.jpg",
  PC_VIKRAM_CLEAN_POSTER_1_3273_5: "/images/pc_vikram_clean_poster_1_3273.jpg",
  ETERNAL_LOVE_POSTER: "/images/Eternal_love_poster.jpg",
  THE_MONSTER_POSTER_1: "/images/the_monster_poster_1.jpg",
  SEE_NO_EVIL_FINAL_REVENGE_1: "/images/see_no_evil_final_revenge_1.jpg",
  ACT_OF_VENGEANCE_CINEMATIC_1: "/images/act_of_vengeance_cinematic_1.jpg",
  I_LOVE_YOUR_WIFE_POSTER: "/images/i_love_your_wife_age_appropriate_drama_poster_1.jpg",
  WHATSAPP_CASE333: "/images/WhatsApp Image 2026-04-02 at 04.10.42.jpeg",
  SIRF_TERE_LIYE: "/images/sirf_tere_liye_obsession_madness_love_1.jpg",
  THREE_DUFFERS: "/images/3_duffers_cinematic_detailed_1.jpg",
  INDIAN_TADKA_POKER: "/images/script_poster_poker_night_v1_1.jpg",
  KOI_MIL_GAYE: "/images/koi_mil_gayi_poster_edited_1.jpg",
  AFFOO_KHUDAYA: "/images/affoo_khudaya_dark_humor_1.jpg",
  NAWABISTAN: "/images/nawabistan_shore_rivalry_closeup_1.png",
  KESHHAV_ONSET_ON_SET: "/images/keshhav_onset_1_1.jpg",
  DIMENSIONS_OF_LOVE: "/images/dimensions_v3_1.jpg",
  BODY_SNATCHER: "/images/body_snatcher_character_poster_1.jpg",
  JEENA_MOVIE_BANNER: "/images/467898770_10161884086919866_2473197727237720433_n.jpg",
  HERO_INTRO_GIF: "/images/ezgif.com-video-to-gif-converter.gif",
} as const;

export type ImageKey = keyof typeof IMAGES;
